import SavedItemsItemsHeader from "../../common/SavedItemsItemsHeader";

const ItemsHeader = () => <SavedItemsItemsHeader />;

export default ItemsHeader;
